import { VERSION } from '@env';

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';

import { SnTitleService } from '@lib/state/title';

import { SnLayoutService } from '../../services';

@Component({
  selector: 'sn-layout-navbar-primary',
  templateUrl: './layout-navbar-primary.component.html',
  styleUrls: ['./layout-navbar-primary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'sn-layout-navbar__primary' },
})
export class SnLayoutNavbarPrimaryComponent {
  @Input()
  public logoIsCollapse: boolean;

  @Input()
  public isDark: boolean;

  @Input()
  public version: string = VERSION;
  public backendVersion: string = localStorage.getItem('backendVersion');

  constructor(
    private readonly _router: Router,
    private readonly _layout: SnLayoutService,
    private readonly _title: SnTitleService,
  ) {}

  public goToMap(): void {
    this._router.navigate(['/map']);
    this._layout.navbar.close();
    this._layout.appbar.search.activate();
    this._title.setTitle('Map');
  }
}
